import selectRawPrices from '../select-raw-price';
import type { RootState } from '../../reducers';

const selectPrices = (state: RootState) => selectRawPrices(state)?.data ?? null;

export default selectPrices;
